export interface EmailAddress {
	EmailAddressId: number;
	Address: string;
	IsActive: boolean;
	TopicsTO: string | null;
	TopicsCC: string | null;
	TopicsBCC: string | null;
}

export interface EmailAddressFormValues {
	EmailAddressId: number | null;
	Address: string;
	TopicIdsTO: number[];
	TopicIdsCC: number[];
	TopicIdsBCC: number[];
}

export const INITIAL_VALUES: EmailAddressFormValues = {
	EmailAddressId: null,
	Address: "",
	TopicIdsTO: [],
	TopicIdsCC: [],
	TopicIdsBCC: [],
};
